import React from 'react';
import _ from 'lodash';
import { Box, Card, CardHeader, CardContent, Typography, FormControl } from '@mui/material';

import DocumentsButtons from './DocumentsButtons';
import { SmallFormTextField } from '../../../../../../components/small-fields/SmallFormTextField';
import { useSelector } from 'react-redux';
import WRDocumentsButtons from './WRDocumentsButtons';

const DocumentsAndNotifications = ({ formik }) => {
  const { seasonIdentifier, module } = useSelector(state => state.app);

  return (
    <Card>
      <CardHeader title="Dokumenty"></CardHeader>
      <CardContent>
        <FormControl>
          <Typography variant="subtitle2">Sposób wysyłki umowy</Typography>
          <SmallFormTextField
            sx={{ width: 200 }}
            select
            name="way_of_sending_contract"
            placeholder="sposób wysyłki umowy"
            options={[{ value: 'email', label: 'E-mail' }, { value: 'traditional_mail', label: 'Poczta tradycyjna' }]}
            value={formik.values.way_of_sending_contract}
            onChange={e => formik.handleChange(e)}
            disabled={['l_25', 'l_26', 'l_27', 'l_25_wr', 'l_26_wr', 'l_27_wr', 'l_26_zs', 'l_27_zs'].includes(seasonIdentifier) ? true : false}
          />
        </FormControl>
        <Box height={40} />
        {module == 'wyjazdy_rodzinne' ? <WRDocumentsButtons /> : <DocumentsButtons />}
      </CardContent>
    </Card>
  );
};


export default DocumentsAndNotifications;
